/** Max age of a session established via email OTP (`user_metadata.otp_login_at`). */
export const OTP_SESSION_MAX_MS = 24 * 60 * 60 * 1000;

/**
 * True when this auth user is on a code-based session that has passed the 24h cap.
 * Password sessions (`last_auth_method` is `'password'` or unset) are never expired here.
 *
 * @param {import('@supabase/supabase-js').User | null | undefined} authUser
 * @param {number} [now]
 */
export function otpSessionIsExpired(authUser, now = Date.now()) {
  const meta = authUser?.user_metadata;
  if (!meta || meta.last_auth_method !== 'otp') return false;
  const loginAt = Date.parse(meta.otp_login_at || '');
  if (Number.isNaN(loginAt)) return true;
  return now - loginAt > OTP_SESSION_MAX_MS;
}
